export const FAV_GAMES_LIST='fav_games_list';
export const FAV_SPORTS_LIST='fav_sports_list';

export const RECC_SPORTS_LIST='recc_sports_list';
export const RECC_GAMES_LIST='recc_games_list';
export const PROVIDER_LIST='provider_list';